import { render, staticRenderFns } from "./FichaFinanceira.vue?vue&type=template&id=5bdfbb08&"
import script from "./FichaFinanceira.vue?vue&type=script&lang=js&"
export * from "./FichaFinanceira.vue?vue&type=script&lang=js&"
import style0 from "./FichaFinanceira.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports